
import { NOTIFICATION_WORKFLOW_MODAL_KEY } from '../constants';
import Vue from 'vue';
import { restApi } from '@/components/mixins/restApi';
import mixins from 'vue-typed-mixins';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';
import InfoAliare from '@/components/InfoAliare.vue';

import Modal from './Modal.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import { removeItemFromArrayByValue } from '@/components/helpers';

import AliareInput from '@/components/AliareInput.vue';

import WebStorage from '@/common/WebStorage';
import ScrollInfinite from '@/components/ScrollInfinite.vue';


import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import { copyPaste } from '@/components/mixins/copyPaste';
import InteractionMenu from '@/components/InteractionMenu.vue';
import AlertNotificationModal from '@/components/AlertNotificationModal.vue';


export default mixins(
	restApi,
	workflowHelpers,
    copyPaste,
).extend({
	name: 'NotificationWorkflowModal',
	components: {
		Modal,
		ModalButtonCancel,
        InfoAliare,
        AliareInput,
        ScrollInfinite,
		ModalButtonSuccess,
        AlertNotificationModal,
		InteractionMenu,
	},
    props: {
		dataModal: {
			type: Object,
    },
	},
	data() {
		return {
			modalBus: new Vue(),
			NOTIFICATION_WORKFLOW_MODAL_KEY,
			isLoadingPage: false,
            isLoadingList: false,
            searchInput: '',
            notificationsSelected: [],
            notificationList: [],
            notificationListTemp: [],
            page: 1,
            pageSize: 10,
            isSearching: false,
            showAlert: false,
            scrollInfinite: true,
		};
	},
	computed: {
        canSaveNotification() {
            return this.notificationsSelected.length > 0;
        },
        workspace() {
			return this.$store.getters.workspace;
		},
        keepText() {
            return 'Desativar';
        },
        discardText() {
            return 'Cancelar';
        },
        alertNotificationDescription() {
            return 'Você tem certeza que deseja desativar todas as notificações?';
        },
        dynamicTextInfo() {
            return (this.notificationsSelected.length ? '' : 'Este fluxo ainda não possui notificações selecionadas. ') + 'Ao definir notificações para o fluxo, as mesmas serão enviadas de acordo com o resultado da execução e os parâmetros das notificações selecionadas.';
        },
        isMultiple() {
            return this.dataModal.mode == 'multiple';
        },
	},
	async mounted () {

	},
	async created() {
        this.isLoadingPage = true;
        await this.getNotificationsList();
        this.isLoadingPage = false;
	},
	methods: {
        capitalize(str) {
			if (!str) return '';
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		},
        searchNotifications:
		_.debounce(async function (e)  {
            if (this.searchInput.length === 0) {
                this.notificationList = this.notificationListTemp;
                this.isSearching = false;
                this.scrollInfinite = true;

                return;
            }
            if (this.searchInput.length < 3) {
                return;
            }
            if (!this.isSearching) {
                this.notificationListTemp = this.notificationList;
            }

            this.isLoadingList = true;
            this.isSearching = true;
            this.scrollInfinite = false;

            const payload = {
                size: 10,
                SearchNome: this.searchInput,
            };

            this.notificationList = await this.restApi().getNotifications(payload);
            this.isLoadingList = false;
			
		}, 500),
        verifyNotificationSelected(verifyNotification){
			return this.notificationsSelected.find(notification => notification.id === verifyNotification.id);
        },

        toggleNotification(notification) {
			if (this.verifyNotificationSelected(notification)) {
				removeItemFromArrayByValue(this.notificationsSelected, notification);
			} else {
				this.notificationsSelected.push(notification);
			}
		},
        async disableNotification() {
            try {
                this.isLoadingPage = true;
                let payload = {
                    workflowsId: []
                };
                if (this.isMultiple) {
                    payload.workflowsId.push(...this.dataModal.selectedWorkflows.map(workflow => workflow.id))
                } else {
                    payload.workflowsId = [this.dataModal.workflowId];
                }
                
                
                await this.restApi().removeNotificationsWorkflow(this.workspace.id, payload).then((response) => {
                    if (response) {
                        this.$store.commit('activeAlert', {
                            message: this.isMultiple ? 'As notificações que estavam vinculadas aos fluxos foram desvinculadas.' : 'As notificações que estavam vinculadas ao fluxo foram desvinculadas.',
                            status: 'success',
                        });
                        this.modalBus.$emit('close');

                    }
                });
            } catch (error) {
                console.error(error);
                this.$store.commit('activeAlert', {
                    message: this.isMultiple ? 'Ocorreu um erro ao desvincular as notificações dos fluxos.' : 'Ocorreu um erro ao desvincular a notificação do fluxo.',
                    status: 'error',
                });
            } finally {
                this.isLoadingPage = false;
            }
        },
        async pagination() {
            this.page++;

            const payload = {size: this.pageSize, page: this.page };
            
			await this.restApi().getNotifications(payload).then((response) => {
                const existingIds = new Set(this.notificationList.map(n => n.id));
                const newNotifications = response.filter(n => !existingIds.has(n.id));
                
                this.notificationList.push(...newNotifications);
				 if (response.length < 10) {
					this.scrollInfinite = false;
				}
			});
        },

        async saveNotificationToWorkflow() {
            
            try {
                const notificationsSelectedIds = this.notificationsSelected.map((notification) => notification.id) || [];
                this.isLoadingPage = true;
                let payload = {
                    notificacoesId: notificationsSelectedIds,
                    workflowsId: []
                };
                if (this.isMultiple) {
                    payload.workflowsId.push(...this.dataModal.selectedWorkflows.map(workflow => workflow.id))
                } else {
                    payload.workflowsId = [this.dataModal.workflowId];
                }
                
                
                await this.restApi().saveNotificationInWorkflow(this.workspace.id, payload).then((response) => {
                    if (response) {
                        this.$store.commit('activeAlert', {
                            message: this.isMultiple ? 'A configuração de notificações foi salvo nos fluxos com sucesso!' : 'A configuração de notificações foi salvo no fluxo com sucesso!',
                            status: 'success',
                        });
                        this.modalBus.$emit('close');

                    }
                });
            } catch (error) {
                console.error(error);
                this.$store.commit('activeAlert', {
                    message: this.isMultiple ? 'Ocorreu um erro ao vincular as notificações aos fluxos.' : 'Ocorreu um erro ao vincular a notificação ao fluxo.',
                    status: 'error',
                });
            } finally {
                this.isLoadingPage = false;
            }
            
        },

        async getNotificationsList() {
			const payload = {size: this.pageSize, page: this.page };

            if (!this.isMultiple) {
                await this.restApi().getNotificationWorkflow(this.workspace.id, this.dataModal.workflowId).then((response) => {
                    this.notificationsSelected.push(...response);
                    this.notificationList = response;
                });
            }
            
			await this.restApi().getNotifications(payload).then((response) => {
                const existingIds = new Set(this.notificationList.map(n => n.id));
                const newNotifications = response.filter(n => !existingIds.has(n.id));
                
                this.notificationList.push(...newNotifications);
                
				 if (response.length < 10) {
					this.scrollInfinite = false;
				}
			});
		},

	},
});
